


















import { defineComponent, computed } from '@vue/composition-api';
import TextsSearch from './TextsSearch/TextsSearch.vue';
import WordsInTextsSearch from './TextsSearch/WordsInTextSearch.vue';
import DictionarySearch from './DictionarySearch/DictionarySearch.vue';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'SearchView',
  components: {
    TextsSearch,
    DictionarySearch,
    WordsInTextsSearch,
  },
  setup() {
    const store = sl.get('store');

    const canDictionarySearch = computed(
      () =>
        store.hasPermission('WORDS') ||
        store.hasPermission('NAMES') ||
        store.hasPermission('PLACES')
    );
    return {
      canDictionarySearch,
    };
  },
});
